import { render, staticRenderFns } from "./AllProperties.vue?vue&type=template&id=a024b724&scoped=true&"
import script from "./AllProperties.vue?vue&type=script&lang=js&"
export * from "./AllProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a024b724",
  null
  
)

export default component.exports